import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button, { ButtonType } from '~/components/shared/Button/button';
import Icon, { SvgSrc } from '~/components/shared/Icon/Icon';
import Stack from '~/components/shared/Layout/Stack';
import { Stack as H7 } from '@qred/components-library';
import { useKlarnaFlow } from '~/hooks/useKlarnaFlow/useKlarnaFlow';
import useModals from '~/hooks/useModals';
import useTranslate from '~/hooks/useTranslate';
import { pushToGtmOnboardingAction } from '~/store/actions/gtmActions';
import { RootState } from '~/store/types/sharedTypes';
import { theme } from '~/styles/themes';
import UploadDocumentsModalBody from './components/UploadDocumentsModalBody';

export const UploadDocuments = () => {
  const dispatch = useDispatch();
  const {
    onboardingApplication: {
      form: { bankFilesUploaded },
    },
    matchedMedia,
  } = useSelector((state: RootState) => state);

  useKlarnaFlow();
  const t = useTranslate();
  const modals = useModals();

  const handleOpenUploadDocumentsModal = () => {
    modals.openModal({
      id: 'uploadDocuments-modal',
      header: <H7>{t('Onboarding.UploadFilesModalTitle')}</H7>,
      children: <UploadDocumentsModalBody />,
      size: 'md',
      fullScreen: matchedMedia.smallScreenPortrait,
      fixedHeaderAndFooter: true,
      hasOwnFooter: true,
      filledBackground: true,
      showBackButton: true,
    });

    dispatch(
      pushToGtmOnboardingAction({
        actionName: 'open_upload_documents_modal',
      })
    );
  };

  useEffect(() => {
    if (bankFilesUploaded) {
      handleOpenUploadDocumentsModal();
    }

    return () => {
      modals.closeModal('uploadDocuments-modal');
    };
  }, []);

  return (
    <Stack
      alignContent="center"
      wrap={!matchedMedia.mobile ? 'wrap' : undefined}
    >
      <Button
        type={ButtonType.SecondaryInverted}
        fullWidth
        onClick={handleOpenUploadDocumentsModal}
        textColor={theme.colors.dark}
        dataCy="onboarding_upload_documents_button"
      >
        <Icon src={SvgSrc.FileUpload} mr={0.5} />
        {t('Onboarding.UploadBankTransactions')}
      </Button>
    </Stack>
  );
};
